<template>
  <div class="container">
    <div class="box">
      <div class="right">
        <img src="../../assets/image/logo.png" />
      </div>
      <div class="left">
        <router-link :style="{'color': tab==1 ? '#122a8a' : '#7983a6' }" to="/">首页</router-link>
        <router-link :style="{'color': tab==2 ? '#122a8a' : '#7983a6' }" to="/product">产品中心</router-link>
        <router-link :style="{'color': tab==3 ? '#122a8a' : '#7983a6' }" to="/about">关于我们</router-link>
        <router-link :style="{'color': tab==4 ? '#122a8a' : '#7983a6' }" to="/partners">合作伙伴</router-link>
        <router-link :style="{'color': tab==5 ? '#122a8a' : '#7983a6' }" to="/news">新闻资讯</router-link>
        <router-link :style="{'color': tab==6 ? '#122a8a' : '#7983a6' }" to="/contact">联系我们</router-link>
      </div>
    </div>
  </div>
</template>

<<script>
export default {
  props:['tab'],
  data() {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
.container {
    width:100%;
  height: 50px;
  background-color: #e3effb;
  .box {
    display: flex;
    justify-content: space-around;
    align-items:center;
    .right {
      width: 50px;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .left {
      a{
        margin-right:20px
      }
    }
  }
}
a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}
</style>
